













import _, { reduce } from 'lodash';
import numeral from 'numeral';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {GoalSettingColumns} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/GoalSettingColumns';
import {
  columnGoalSetting,
  EconomicGroup,
  Families,
  IEconomicGroupGoalsDetails,
  inputColumnGoalSetting,
  inputManualColumnGoalSetting,
  numberColumnGoalSetting,
  percentColumnGoalSetting,
  percentIndustryColumnGoalSetting
} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/types';
import {NumberHelper} from '@/utils/number.helper';
import {SaleTypeEnum} from '@/modules/neodash/model/types/enums/saleTypeEnum';

@Component({
  name: 'TableViewFooterGoalSettingComponent'
})
export default class TableViewFooterGoalSettingComponent extends Vue {
  public numeral = numeral;

  @Prop({required: true})
  public columns: GoalSettingColumns;

  @Prop({required: true})
  public economicGroup: EconomicGroup;

  @Prop({required: true})
  public families: Families;

  public getDistinctValues(selector: (obj: IEconomicGroupGoalsDetails) => number, families:any = []): Array<number> {
    if (families) {
      return _.uniqWith(this.sales, (arrVal, othVal) => {
        return arrVal.nameSegment === othVal.nameSegment
          && arrVal.idSaleType === othVal.idSaleType
          && families.includes(othVal.idFamily);
      }).map(selector);
    }

    return _.uniqWith(this.sales, (arrVal, othVal) => {
      return arrVal.nameSegment === othVal.nameSegment && arrVal.idSaleType === othVal.idSaleType;
    }).map(selector);
  }

  public getDistinctFamilies(selector: (obj: IEconomicGroupGoalsDetails) => number, families: number[]): Array<number> {
    return this.sales.filter(x => !families.includes(x.idFamily)).map(selector);
  }

  public getFormat(col: columnGoalSetting): string {
    const dict = [
      {typeElement: 'number', format: '0.0'},
      {typeElement: 'percent', format: '0.0%'},
    ];
    const {format} = dict.find(x => x.typeElement === col.typeElement) || dict[0];
    return format;
  }

  public getValue(col: columnGoalSetting): string | number {
    let result: number;
    if ((col as inputManualColumnGoalSetting).isManualInput)
      return '';

    if ((col as numberColumnGoalSetting).getterValuePerMonth) {
      if ((col as numberColumnGoalSetting).distinctValues && (col as numberColumnGoalSetting).distinctByFamilies.length > 0) {
        return Array.from(this.getDistinctFamilies((col as numberColumnGoalSetting).getterValuePerMonth, (col as numberColumnGoalSetting).distinctByFamilies)).sum();
      }

      if ((col as numberColumnGoalSetting).distinctValues) {
        return Array.from(this.getDistinctValues((col as numberColumnGoalSetting).getterValuePerMonth)).sum();
      }

      return this.sales.sumBy((col as numberColumnGoalSetting).getterValuePerMonth);
    }

    if ((col as percentIndustryColumnGoalSetting).getterOver) {
      let value = col as percentIndustryColumnGoalSetting;

      if (value.withSubtract) {
        let sumIndustryNextYear = Array.from(this.getDistinctValues(value.getterTotal, value.distinctByFamilies)).sum();
        let sumIndustryLastYear = Array.from(this.getDistinctValues(value.getterOver, value.distinctByFamilies)).sum();

        if (value.getterMonthIndustryTotal) {
          sumIndustryNextYear = Array.from(this.getDistinctValues(value.getterMonthIndustryTotal, value.distinctByFamilies)).sum();
        }

        if (value.getterMonthOverValue) {
          sumIndustryLastYear = Array.from(this.getDistinctValues(value.getterMonthOverValue, value.distinctByFamilies)).sum();
        }

        if (sumIndustryLastYear === 0) {
          return numeral(0).format('0.0%');
        }

        const total = (sumIndustryNextYear / sumIndustryLastYear) - 1;

        return numeral(total).format('0.0%');
      }

      let total = Array.from(this.getDistinctValues(value.getterTotal, value.distinctByFamilies)).sum();
      let over = Array.from(this.getDistinctValues(value.getterOver)).sum();

      if (value.getterMonthOverValue) {
        over = Array.from(this.getDistinctValues(value.getterMonthOverValue)).sum();
      }

      if (value.getterMonthIndustryTotal) {
        total = Array.from(this.getDistinctValues(value.getterMonthIndustryTotal, value.distinctByFamilies)).sum();
      }
             
      result = over / total;

      return result;
    }

    if ((col as percentColumnGoalSetting).getterOver) {
      const value = col as percentColumnGoalSetting;
      if (value.getterOver) {
        const total = Array.from(this.getDistinctValues(value.getterTotal)).sum();
        const over = this.sales.sumBy(value.getterOver);
        result = over / total;
        return result;
      }
    }

    return '';
  }

  public getShareInput(col: inputColumnGoalSetting): string {
    if ((col as inputManualColumnGoalSetting).isManualInput)
      return '';

    const total = this.getDistinctValues(this.columns.getInputShareTotalProp, col.distinctByFamilies).sum();
    const over = this.sales.sumBy(col.getterValue);

    return NumberHelper.percent(total, over);
  }

  public getFamiliesRuleValue(): any {
    return Object.values(this.families)
      .reduce((acc, curr) => {
        acc[curr.id] = curr.rules[0].valueMinimum;
        return acc;
      }, {});
  }

  public get sales(): IEconomicGroupGoalsDetails[] {
    const saleType = this.columns.saleType.value;
    const details = this.economicGroup.details.filter(x => saleType === x.idSaleType || saleType === SaleTypeEnum.AllOfIt);
    const familiesRuleValue = this.getFamiliesRuleValue();

    return details.map(x => {
      const data = {...x, familyRuleValue: familiesRuleValue[x.idFamily]};
      return data;
    })
  }
}
